require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.get = function (r, e, s) {
  try {
    if (e in r) return r[e];
    Array.isArray(e) && (e = "['" + e.join("']['") + "']");
    var t = r;
    return e.replace(/\[\s*(['"])(.*?)\1\s*\]|^\s*(\w+)\s*(?=\.|\[|$)|\.\s*(\w*)\s*(?=\.|\[|$)|\[\s*(-?\d+)\s*\]/g, function (r, e, s, n, i, o) {
      t = t[s || n || i || o];
    }), void 0 == t ? s : t;
  } catch (r) {
    return s;
  }
};